export default "__VITE_ASSET__CZR4gyzz__"